// extracted by mini-css-extract-plugin
module.exports = {"countryMedalCount":"MedalsByGames_countryMedalCount__2IzLh","countryName":"MedalsByGames_countryName__2M0aJ"};